import { Stack } from '@mui/system';
import React, { useState, useContext, useEffect } from 'react';
import { ChatsContext } from 'src/context/chats';
import { PortalContext } from 'src/context/portal';
import { Chat } from './Chat';
import { Header } from './Header';
import { setNeededChat } from './helpers';
import { SendMessage } from './SendMessage/SendMessage';
import { TaskModal } from './TaskModal';
import { buildDataTestId } from 'src/utils/functionHelpers';

type DialogProps = {
  dataTestId?: string;
};

export const Dialog: React.FC<DialogProps> = ({ dataTestId }) => {
  const [isOpenTaskModal, setIsOpenTaskModal] = useState<boolean>(false);
  const { activeChat, chats } = useContext(ChatsContext);
  const { patientName, patientId, orderId, labCode, conversationId } = useContext(PortalContext);

  useEffect(() => {
    if (chats.length > 0) setNeededChat(chats, patientId, labCode, conversationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chats]);

  return activeChat || patientName || orderId ? (
    <Stack sx={{ height: '100%' }}>
      <Header
        setIsOpenTaskModal={setIsOpenTaskModal}
        dataTestId={buildDataTestId(dataTestId, 'header')}
      />
      <Chat dataTestId={buildDataTestId(dataTestId, 'chat')} />
      <SendMessage dataTestId={buildDataTestId(dataTestId, 'send-message')} />
      <TaskModal
        isOpenTaskModal={isOpenTaskModal}
        setIsOpenTaskModal={setIsOpenTaskModal}
        patientId={patientId}
        dataTestId={buildDataTestId(dataTestId, 'modal-task')}
      />
    </Stack>
  ) : null;
};
